/**
 * CalcEmptyNotice — shared amber warning marker for an empty «Расчёт» body
 * (KAN-123).
 *
 * A leaf service (calculator/pricelist/classifier/questionnaire) is REQUIRED
 * to carry calc data (chains / pricing_data / questionnaire_fields) — see
 * `.claude/rules/service-principles.md`. So an empty «Расчёт» section is
 * ALWAYS an indexing defect, never a legitimate empty state, and must be
 * visually distinct from ordinary muted UI text (KAN-123) so it isn't missed.
 *
 * Matches the existing amber-warning convention used elsewhere in this
 * codebase (DeleteServiceDialog's «cascade-warning», TreeTestResultPanel).
 */
import { AlertTriangle } from 'lucide-react';

export function CalcEmptyNotice({ testid, message }: { testid: string; message: string }): JSX.Element {
  return (
    <div
      data-testid={testid}
      className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800"
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
